import { Option } from '../option.js';
import { PModel, PropertyPath } from '../engine.js';
import { CompatibilityTable, Hash } from './CompatibilityTable.js';
import { CompatibilityService } from './CompatibilityService.js';
import { IndexedRules } from './IndexedRules.js';

/**
 * !!! Doesn't support externalFields and indirect relationships between options !!!
 */
export class CompatibilityFilter {
  private indexedRulesByOptionPath = new Map<PropertyPath, IndexedRules[]>();


  constructor(
    private model: PModel,
    private compatibilityService: CompatibilityService
  ) {
    this.createIndexes();
  }

  match(propertyPath: PropertyPath, option: Option): boolean {
    const values = this.indexedRulesByOptionPath.get(propertyPath) ?? [];
    const len = values.length;
    let i = 0;
    for (; i < len; i++) {
      const value = values[i];
      const optionHash = value.optionSelectors.get(propertyPath)(option);
      const result = value.matchOne(propertyPath, optionHash);
      if (!result) {
        return false;
      }
    }
    return true;
  }

  filter(propertyPath: PropertyPath, options: Option[]): Option[] {
    const result: Option[] = [];
    for (let option of options) {
      if (this.match(propertyPath, option)) {
        result.push(option);
      }
    }
    return result;
  }

  applyOption(propertyPath: PropertyPath, option: Option) {
    // TODO: Optimization: store applied filters, if it is off, no need for reset
    this.resetOption(propertyPath);
    const indexedRulesGroup = this.indexedRulesByOptionPath.get(propertyPath) ?? [];
    for (let indexedRules of indexedRulesGroup) {
      //TODO: preprocess option hashes on top level
      const optionHash = indexedRules.optionSelectors.get(propertyPath)(option);
      indexedRules.applyFilter(propertyPath, optionHash)
    }
  }

  resetOption(propertyPath: PropertyPath) {
    const indexedRulesGroup = this.indexedRulesByOptionPath.get(propertyPath) ?? [];
    for (let indexedRules of indexedRulesGroup) {
      indexedRules.resetFilter(propertyPath);
    }
  }

  private createIndexes() {
    for (const [tableName, table] of this.compatibilityService.tables) {
      if (!table.isCompatibilitySwitchedOff(this.model)) {
        this.createIndexFor(tableName, table);
      }
    }
  }

  private createIndexFor(tableName: string, table: CompatibilityTable) {
    const indexedRules = new IndexedRules(table);
    const optionPaths = indexedRules.involvedOptionPaths;
    for (let path of optionPaths) {
      let indexedRulesGroup = this.indexedRulesByOptionPath.get(path)
      if (!indexedRulesGroup) {
        indexedRulesGroup = [];
        this.indexedRulesByOptionPath.set(path, indexedRulesGroup);
      }
      indexedRulesGroup.push(indexedRules);
    }
  }

  anyMath(optionPath: PropertyPath): boolean {
    const indexedRulesGroup = this.indexedRulesByOptionPath.get(optionPath) ?? [];
    //TODO: Rewrite with loop for performance
    return indexedRulesGroup.every(indexedRules => indexedRules.anyMatch());
  }

  // private getOptionHash(indexedRules: IndexedRules, propertyPath: PropertyPath, option: Option) {
  //   return indexedRules.optionSelectors.get(propertyPath)(option);
  //
  //   let map = this.optionHashCache.get(option)
  //   if (!map) {
  //     map = new Map<PropertyPath, Hash>();
  //     this.optionHashCache.set(option, map);
  //   }
  //   let optionHash = map.get(propertyPath);
  //   if (!optionHash) {
  //     optionHash = indexedRules.optionSelectors.get(propertyPath)(option);
  //     map.set(propertyPath, optionHash);
  //   }
  //   return optionHash;
  // }
  resetAll() {
    for (const indexedRules of this.indexedRulesByOptionPath.values()) {
      for (const indexedRule of indexedRules) {
       indexedRule.resetAll();
      }
    }
  }
}
